import { render, staticRenderFns } from "./Multiplier.vue?vue&type=template&id=22dd392a&"
import script from "./Multiplier.vue?vue&type=script&lang=js&"
export * from "./Multiplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports